<div
  class="container"
  nz-flex
  [nzVertical]="false"
  nzJustify="space-between"
  nzAlign="center"
>
  <div
    nz-flex
    [nzVertical]="false"
    nzJustify="start"
    nzAlign="center"
    nzGap="1.5rem"
    class="left-section"
  >
    <div
      nz-flex
      [nzVertical]="false"
      nzJustify="start"
      nzAlign="center"
      nzGap="0.5rem"
      (click)="redirectToHomePage()"
      (keydown.enter)="redirectToHomePage()"
      class="logo-container"
    >
      <img
        src="assets/images/longhealth-navbar-logo.png"
        alt=""
        class="navbar-logo"
      />
      <span nz-typography class="logo-text">| EvalPath</span>
    </div>
    @if (this.isLoggedIn() && !this.isPatientQuestionnairePage()) {
      <ul nz-menu nzMode="horizontal" class="nav-menu nav-pill-group">
        <li nz-menu-item nzMatchRouter class="nav-pill-item">
          <a class="nav-pill-link" [routerLink]="['/home']">Cases</a>
        </li>
        <li nz-menu-item nzMatchRouter class="nav-pill-item">
          <a class="nav-pill-link" [routerLink]="['/settings']">Settings</a>
        </li>
        @if (complimentaryAccessLabel(); as accessLabel) {
          <li nz-menu-item class="nav-pill-item complimentary-access-item">
            <a
              class="nav-pill-link complimentary-access-link"
              [routerLink]="['/settings/billing']"
              aria-label="View Complimentary Access details in Billing"
            >
              Complimentary access · {{ accessLabel }}
            </a>
          </li>
        }
      </ul>
    }
  </div>
  <div class="btn-container">
    @if (this.isLoggedIn() && !this.isPatientQuestionnairePage()) {
      <div
        class="user-options-container"
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="menu"
        (nzVisibleChange)="onDropdownVisibleChange($event)"
      >
        <nz-avatar
          class="user-icon"
          [nzText]="organizationUser()?.firstName?.charAt(0) || 'U'"
        ></nz-avatar>
        <div class="user-options">
          <div class="user-info">
            <span class="user-name">
              {{ organizationUser()?.firstName ?? '' }}
              {{ organizationUser()?.lastName ?? '' }}
            </span>
            <span class="user-email">
              {{ organizationUser()?.email ?? '' }}
            </span>
          </div>
        </div>
        <span
          class="down-icon"
          [class.rotated]="isDropdownOpen()"
          nz-icon
          nzType="down"
          nzTheme="outline"
        ></span>
      </div>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="logout()" (keydown.enter)="logout()">
            <div class="dropdown-menu-li-container">
              <span nz-icon nzType="logout" nzTheme="outline"></span>
              <span>Logout</span>
            </div>
          </li>
        </ul>
      </nz-dropdown-menu>
    } @else if (!this.isPatientQuestionnairePage()) {
      <button nz-button nzType="primary" (click)="routeToLogin()">Login</button>
    }
  </div>
</div>
